import React, { useState } from "react";

const Header = ({ onGetStarted }) => {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-white/80 backdrop-blur-md border-b border-gray-100">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <div className="flex items-center justify-between py-4">
          <div className="flex items-center">
            <div className="text-green-500 mr-2">
              <img 
                src="/logo.png" 
                alt="Hyperrank" 
                className="h-10 w-auto"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.style.display = 'none';
                }}
              />
            </div>
          </div>

          {/* Desktop Nav */}
          <nav className="hidden md:flex space-x-8">
            <a href="#how-it-works" className="text-gray-700 hover:text-green-500 transition-colors duration-200 font-medium">
              How it works
            </a>
            <a
              href="#writing-examples"
              className="text-gray-700 hover:text-green-500 transition-colors duration-200 font-medium"
            >
              Writing Examples
            </a>
            <a href="#pricing" className="text-gray-700 hover:text-green-500 transition-colors duration-200 font-medium">
              Pricing
            </a>
            <a href="#blog" className="text-gray-700 hover:text-green-500 transition-colors duration-200 font-medium">
              Blog
            </a>
          </nav>

          {/* Desktop Buttons */}
          <div className="hidden md:flex items-center space-x-4">
            <button className="flex items-center justify-center px-4 py-2 border border-gray-300 rounded-full text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 transition-colors duration-200 shadow-sm">
              <img src="/images/google-logo.webp" alt="Google" className="w-5 h-5 mr-2" />
              Join with Google
            </button>
            <button 
              onClick={onGetStarted}
              className="flex items-center justify-center px-5 py-2.5 rounded-full text-sm font-medium text-white bg-green-500 hover:bg-green-600 transition-all duration-200 shadow-md hover:shadow-lg transform hover:-translate-y-0.5">
              Start for Free
            </button>
          </div>

          {/* Mobile Hamburger */}
          <button
            className="md:hidden flex items-center justify-center p-2 rounded-full hover:bg-gray-100 transition-colors duration-200"
            onClick={() => setMobileNavOpen(!mobileNavOpen)}
            aria-label="Open navigation menu"
          >
            <svg className="h-7 w-7 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;

